import React, { useEffect, useState, useContext } from "react";
import {
  FaHome,
  FaFacebookMessenger,
  FaArchive,
  FaReact,
  FaBriefcase,
} from "react-icons/fa";
import projectWiseLogo from "../../assets/images/projectwise-logo.png";
import { GlobalContext } from "../../App";
import { useNavigate, useLocation } from "react-router-dom";

function SideBar() {
  const { rolexModuleData, roles } = useContext(GlobalContext);
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;

  const [submenuOpen, setSubmenuOpen] = useState("0");

  useEffect(() => {
    const portfolioPaths = [
      "/project-detail",
      "/milestones",
      "/task",
      "/task-detail",
    ];
    const configPaths = [
      "/serial-sequence",
      "/personal-detail",
      "/manage-roles",
      "/change-password",
      "/add-company",
      "/add-business-unit",
      "/add-department",
      "/bulkupload",
    ];
    const userPaths = ["/portal-user", "/client-user"];

    if (portfolioPaths.includes(pathname)) {
      setSubmenuOpen("1");
    } else if (configPaths.includes(pathname)) {
      setSubmenuOpen("2");
    } else if (userPaths.includes(pathname)) {
      setSubmenuOpen("2-1");
    } else {
      setSubmenuOpen("0");
    }
  }, [pathname]);

  const hasPermission = (path) =>
    rolexModuleData?.find(
      (data) => path === data?.description && data?.read === 1
    ) || roles?.find((data) => data?.role_id === 1001);

  const renderMenuItem = (path, icon, title) => {
    if (hasPermission(path)) {
      return (
        <li className="menu-item" key={path}>
          <a
            onClick={() => navigate(path)}
            className={pathname === path ? "active" : ""}
            title={title}
          >
            <span className="menu-icon">{icon}</span>
            <span className="menu-title">{title}</span>
          </a>
        </li>
      );
    }
    return null;
  };
  
  const renderSubMenuItems = (subMenuItems) => {
    return subMenuItems.map(({ path, title }, index) => {
      if (!hasPermission(path)) {
        return null;
      }
      const isActive = pathname === "/task-detail" ? path === "/task" : pathname === path;
      return (
        <li className="menu-item" key={`${path}-${index}`}>
          <a
            onClick={() => navigate(path)}
            className={isActive ? "active" : ""}
          >
            <span className="menu-title">{title}</span>
          </a>
        </li>
      );
    }).filter(item => item !== null);
  };
  

  const renderSubMenu = (title, icon, subMenuItems, subMenuKey) => (
    <li
      className={`menu-item sub-menu ${submenuOpen === subMenuKey ? "open" : ""}`}
      key={subMenuKey}
    >
      <a onClick={() => setSubmenuOpen(submenuOpen === subMenuKey ? "0" : subMenuKey)}>
        <span className="menu-icon">{icon}</span>
        <span className="menu-title">{title}</span>
      </a>
      <div
        className={`sub-menu-list ${submenuOpen === subMenuKey ? "sub-list-open" : ""}`}
      >
        <ul>{renderSubMenuItems(subMenuItems)}</ul>
      </div>
    </li>
  );

  const renderPortfolioSubMenu = () => {
    const subMenuItems = [
      { path: "/project-detail", title: "Projects" },
      { path: "/milestones", title: "Milestones" },
      { path: "/task", title: "Tasks" },
    ];

    return renderSubMenu("Portfolio", <FaBriefcase />, subMenuItems, "1");
  };

  const renderManageUserSubMenu = () => {
    const subMenuItems = [
      { path: "/portal-user", title: "Portal Users" },
      { path: "/client-user", title: "Client Users" }
    ];

    return renderSubMenu("Manage Users", <FaFacebookMessenger />, subMenuItems, "2-1");
  };

  const renderSetupConfigSubMenu = () => {
    const subMenuItems = [
      { path: "/serial-sequence", title: "Serial Sequence" },
      { path: "/personal-detail", title: "Personal Settings" },
      // {
      //   title: "Manage Users",
      //   icon: <FaFacebookMessenger />,
      //   subMenuItems: [
      //     { path: "/portal-user", title: "Portal Users" },
      //     { path: "/client-user", title: "Client Users" },
      //   ],
      // },
      { path: "/manage-roles", title: "Manage Roles" },
      { path: "/change-password", title: "Change Password" },
      { path: "/bulkupload", title: "Bulk User Upload" },
      { path: "/add-company", title: "Manage Company" },
      { path: "/add-business-unit", title: "Manage Business Unit" },
      { path: "/add-department", title: "Manage Department" },
    ];

    return renderSubMenu("Setup & Config", <FaFacebookMessenger />, subMenuItems, "2");
  };

  return (
    <div
      id="sidebarWrapper"
      className={`sidebarWrap has-sidebar fixed-sidebar fixed-header`}
    >
      <aside className="sidebar break-point-sm has-bg-image">
        <div className="sidebar-layout">
          <div className="sidebar-header">
            <div className="pro-sidebar-logo">
              <img
                src={projectWiseLogo}
                alt="ProjectWise Management Software"
              />
            </div>
          </div>
          <div className="sidebar-content">
            <nav className="menu open-current-submenu">
              <ul>
                {renderMenuItem("/home", <FaHome />, "Home")}
                {renderPortfolioSubMenu()}
                {renderMenuItem("/archive-projects", <FaArchive />, "Archive Projects")}
                {renderMenuItem("/gantt-chart", <FaReact />, "Gantt Chart")}
                {renderSetupConfigSubMenu()}
                {renderManageUserSubMenu()}
              </ul>
            </nav>
          </div>
        </div>
      </aside>
    </div>
  );
}

export default SideBar;
